import React from 'react'
import { Box, Container, Typography } from '@mui/material'
import { useLangNavigate } from '../../../Localization/useLangNavigate';
import FeatureSection from '../../../Components/Public/FeatureSection/FeatureSection';
import CheckNow from '../../../Components/Public/CheckNow/CheckNow';
import BlogLayout from '../../../Components/Public/Blog/BlogLayout';
import BaseButton from '../../../Components/BaseButton';
import { ReactComponent as ErrorPicture } from './picture_404.svg';
import { Txt } from '../../../Routes/Localized';
import { fontLink, fontTextHead } from '../../../base';

export default function ErrorContainer() {
    const navigate = useLangNavigate();

    return (
        <FeatureSection
            title={<Txt id="47010" />}
            text={<Txt id="47016" />}
            textChildren={<>
                <BaseButton text={<Txt id="47011" />} handleSubmit={() => {
                    navigate('');
                }} sx={{ mb: '20px', width: 'fit-content' }} sxButton={{}} sxText={{ px: '12px', ...fontLink }} />
            </>}
            svgImage={ErrorPicture}
            sxInside={{ pt: '100px' }}
            sxText={{ ...fontTextHead }}
            header={true}
        />
    )
}
